import { HsbProject } from './hsb-project';
import { ShareReference } from './sharereference';

export type IfcReference =  {ifcid: string};
export type EntityHandleReference =  {handle: string};
export type EntityReference = IfcReference | EntityHandleReference;

export type IModelReferences =
    {[key:string]:[EntityReference]};


export interface IShareData {
    entityNode: any;
    modelNode: any;
    hsbProject: HsbProject;
    data: any;
    itemType: string;
    references: Array<ShareReference>;
    modelReferences?:  IModelReferences;
    cameraView: CameraView | null;
    readOnly: Boolean;
    clone;
    selected: boolean;
    isNew: boolean;
    entity: any;
    storageTable: DataStorageTable;
    getStorageBaseUrl;
    teamID: string | null;
    userId: string | null;
}

export interface ICloneData<T extends ICloneData<T>> {
    clone() : T;
}

export class CameraView  {
    view: any;

    constructor (view: any) {
        this.view = view;
    }
}


export class ValueSelect implements IValuesSelect {
    key: string;
    value: string;

    constructor (key: any, value:any) {
        this.key = key;
        this.value = value;
    }

    clone() {
        return new ValueSelect(this.key, this.value);
    }
}

export interface IValuesSelect {
    key: string;
    value: string;
    clone() : any;
}

export enum DataStorageTable {
    Project = 'project',
    Team = 'team',
    User = 'user'
}

export class ShareData implements IShareData {
    entityNode: any;
    modelNode: any;
    hsbProject: HsbProject;
    data: any;
    itemType: string;
    references: Array<ShareReference>;
    modelReferences?:  IModelReferences;
    cameraView: CameraView | null;
    readOnly: Boolean = false;
    selected: boolean;
    isNew: boolean;
    entity: any;
    storageTable: DataStorageTable;
    teamID: string | null;
    userId: string | null;
    
    constructor (modelNode: any, hsbProject:HsbProject, tableName: string, data: any, references?: Array<ShareReference>, selected = false) {
        this.entityNode = null;
        this.modelNode = modelNode;
        this.hsbProject = hsbProject;
        this.data = data;
        this.itemType = tableName;
        this.references = references ? references : new Array<ShareReference>();
        this.cameraView = null;
        this.selected = selected;
        this.isNew = false;
        this.entity = null;
        this.storageTable = DataStorageTable.Project;
        this.teamID = null;
        this.userId = null;
        if (modelNode) {
            this.storageTable = modelNode.storageTable;
            if (modelNode.teamID && modelNode.storageTable === DataStorageTable.Team) {
                this.teamID = modelNode.teamID;
            }
            else if (modelNode.userId && modelNode.storageTable === DataStorageTable.User) {
                this.userId = modelNode.userId;
            }
        }
    }

    clone() {
        if (this.data) {
            let newShareData = new ShareData(this.modelNode = null, this.hsbProject, this.itemType, this.data.clone(), this.references.map(reference => reference.clone()), this.selected);
            newShareData.storageTable = this.storageTable;
            newShareData.teamID = this.teamID;
            return newShareData;
        }
    }
    getStorageBaseUrl() {
        let baseUrlName =  '/api/v3/node/data';
        if (this.storageTable === DataStorageTable.Team) {
            baseUrlName =  '/api/v3/team/node/data';
        } else if (this.storageTable === DataStorageTable.User) {
            baseUrlName =  '/api/v3/node/user/data';
        }
        return baseUrlName;
    }
}


